module.exports = __webpack_public_path__ + "img/home-4-line-trans.3f9202d4.svg";